/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchCoaches = {
    properties: {
        team1: {
            type: 'CoachSmallList',
            isRequired: true,
        },
        team2: {
            type: 'CoachSmallList',
            isRequired: true,
        },
    },
} as const;
